var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fl-x"},_vm._l((_vm.path),function(item,i){return _c('div',{key:i,staticClass:"fl-x fs-lg-1"},[_c('span',{staticClass:"mr-lg-2 text-decoration-none"},[_vm._v(" "+_vm._s(item.name)+" ")]),_vm._m(0,true)])}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-lg-2"},[_c('img',{attrs:{"src":require("../../assets/mobile/home/icons/chevron-right-primary-24.png"),"alt":""}})])
}]

export { render, staticRenderFns }